const column = () => {
    const wrapper = document.querySelector('.pg-column-detail-index');
    if (!wrapper) return;

    const list = wrapper.querySelector('ol');
    const items = list.querySelectorAll('li');
    const moreBtn = wrapper.querySelector('.pg-column-detail-index__more');

    const LIMIT = 5; // 表示させる件数

    // 5件以下なら「もっとみる」を消す
    if (items.length <= LIMIT) {
        moreBtn.style.display = 'none';
        return;
    }

    // 5件以上 → 6件目以降を隠す
    items.forEach((item, index) => {
        if (index >= LIMIT) item.style.display = 'none';
    });

    // もっとみるクリックで全部表示
    moreBtn.addEventListener('click', () => {
        items.forEach(item => item.style.display = '');
        moreBtn.style.display = 'none';
    });
};

export default column;
